import { memo, ReactNode, useState } from 'react';
import { Emoji, emojiIndex } from 'emoji-mart';

interface Props {
  name: string | null;
  size?: number;
  className?: string;
}

export function nativeStringByName(name: string) {
  const emojis: any = emojiIndex.search(name);
  if (!emojis) return null;
  return emojis[0].native;
}

const Component = memo((props: Props) => {
  if (!props.name) return null;
  return <Emoji emoji={props.name} size={props.size || 18} />;
});

export default Component;
